<template>
    <div class="profile-events">
        <div class="profile-title">
            <div class="profile-title-wrap">
                <h3>Места</h3>
                <div class="profile-title__icon" @click="openNewPlace()" v-if="itsYou">
                    <font-awesome-icon icon="plus" />
                </div>
            </div>
            <div class="profile-switcher">
            <span @click="changePlacesType('liked')" :class="{active: places_type === 'liked'}">Любимые</span>
            <span @click="changePlacesType('created')" :class="{active: places_type === 'created'}">Созданные</span>
            </div>
        </div>
        <VueSlickCarousel v-if="places.length > 0" :arrows="false" class="profile-slider" :swipeToSlide="true" :variableWidth="true" :infinite="false">
            <div class="profile-event" v-for="place of places" :key="place.id" @mousedown="firstClick"
            @mouseup="openPlace(place, $event)">
            <div class="profile-event__image" :style="{ backgroundImage: 'url(' + place.cover + ')' }">
                <div class="profile-event__label" v-if="!place.cover">Place</div>
                <div class="profile-info">
                <p class="profile-info__date">4 дня назад</p>
                <div class="profile-activity">
                    <div class="profile-activity__item">
                    <!-- <img src="" alt=""> -->
                    <p>14</p>
                    </div>
                    <div class="profile-activity__item">
                    <!-- <img src="" alt=""> -->
                    <p>14</p>
                    </div>
                </div>
                </div>
            </div>
            <div class="profile-tags">
                <p v-for="cat in place.sports" :key="cat.id">{{ cat.ru }} {{ place.sports.length > 1 ? `+ ${place.sports.length - 1}` : '' }}</p>
            </div>
            <p class="profile__text">
                {{ place.title }}
            </p>
            </div>
        </VueSlickCarousel>
        <div v-else class="nothing">Пока что, {{user.firstname}} не создал ни одного места.</div>
    </div>
</template>
<script>
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
export default {
    name: 'ProfilePlaces',
    props: {
        places: {
            type: Array,
            require: true
        },
        itsYou: {
            type: Boolean,
            require: true
        },
        user: {
            type: Object,
            require: true
        }
    },
    data: () => {
        return {
            places_type: 'created',
        }
    },
    components: {
      VueSlickCarousel: () => import("vue-slick-carousel")
    },
    methods: {
        firstClick(event) {
            this.first_click = {
                x: event.clientX,
                y: event.clientY
            }
        },
        openPlace(place, $event) {
            let pos = {
                x: $event.clientX,
                y: $event.clientY
            };
            if (this.first_click.x == pos.x && this.first_click.y == pos.y) {
                this.$store.dispatch('changeMode', false);
                this.$router.push({
                name: 'place',
                params: { hash: place.id + '&' + place.hash },
                });
            }
        },
        openNewPlace() {
            this.$store.dispatch('setNewType', 'places');
            this.$store.dispatch('changeState', {element: 'workplace'});
        },
        changePlacesType(type) {
            this.places_type = type
            this.$store.dispatch('fetchProfilePlaces', {type, user: this.user.id})
        },
    }
}
</script>